import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import {
  JobExperienceLevelEnum,
  JOB_EXPERIENCE_LEVEL_DISPLAY
} from '@umss/shared/data-access';
import { UmssBadgeComponent } from '../badge/badge.component';
import { UmssTooltipDirective } from '../../directives/tooltip.directive';

/**
 * Component to display a badge based on job experience level.
 * Shows experience level (e.g., "EntryLevel") with a tooltip showing the full name (e.g., "Entry Level").
 */
@Component({
  selector: 'umss-job-experience-level-badge',
  standalone: true,
  imports: [UmssBadgeComponent, UmssTooltipDirective],
  template: `
    @if (experienceLevel) {
      <umss-badge
        [variant]="'secondary'"
        [label]="label"
        [outlined]="true"
        [umssTooltip]="displayText"
        tooltipPosition="top"
        [size]="size"
      />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UmssJobExperienceLevelBadgeComponent {
  private _experienceLevel: string = '';
  displayText: string = '';

  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input({ required: true }) set experienceLevel(
    value: JobExperienceLevelEnum | string
  ) {
    this._experienceLevel = value as string;

    this.displayText =
      JOB_EXPERIENCE_LEVEL_DISPLAY[value as JobExperienceLevelEnum] || value;
  }
  get experienceLevel(): string {
    return this._experienceLevel;
  }

  get label(): string {
    return this.displayText || this._experienceLevel || '';
  }
}
